export const versions = {
  revision: 'd6dcd64',
  branch: 'master',
  triadVersion: '1.12.4',
  idpVersion: '1.12.4',
} as const;
